import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  msgs: {},
  error: null,
  loading: false,
};

const agentNotificationStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const agentNotificationSuccess = (state, action) => {
  return updateObject(state, {
    msgs: action.msgs,
    loading: false,
  });
};

const agentNotificationFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENT_NOTIFICATION_START:
      return agentNotificationStart(state, action);
    case actionTypes.AGENT_NOTIFICATION_SUCCESS:
      return agentNotificationSuccess(state, action);
    case actionTypes.AGENT_NOTIFICATION_FAIL:
      return agentNotificationFail(state, action);
    default:
      return state;
  }
};

export default reducer;
